<template>
    <div class="card config-section">
        <CardHeader
            title="Parâmetros de Reserva"
            icon="fas fa-calendar-alt"
        />
        <div class="card-body">
            <div class="section-form">
                <!-- Seção de Limites de Dias -->
<!--                <div class="parameter-section">-->
<!--                    <h6 class="section-subtitle">-->
<!--                        <i class="fas fa-calendar-day mr-2"></i>-->
<!--                        Limites de Reserva-->
<!--                    </h6>-->
<!--                    <div class="row">-->
<!--                        <div class="col-md-6">-->
<!--                            <div class="form-group">-->
<!--                                <label-->
<!--                                    for="max_days"-->
<!--                                    class="form-label"-->
<!--                                >-->
<!--                                    <span class="required">*</span>-->
<!--                                    Máximo de dias permitidos para reserva imediata-->
<!--                                </label>-->
<!--                                <input-->
<!--                                    id="max_days"-->
<!--                                    type="number"-->
<!--                                    class="form-control"-->
<!--                                    :value="value.max_days"-->
<!--                                    @input="updateField('max_days', $event.target.value)"-->
<!--                                    placeholder="Ex: 5"-->
<!--                                    min="1"-->
<!--                                />-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-md-6">-->
<!--                            <div class="form-group">-->
<!--                                <label-->
<!--                                    for="reserve_status_id"-->
<!--                                    class="form-label"-->
<!--                                >-->
<!--                                    <span class="required">*</span>-->
<!--                                    Após {{ value.max_days || 0 }} dias redirecionar para o status-->
<!--                                </label>-->
<!--                                <select-->
<!--                                    id="reserve_status_id"-->
<!--                                    class="form-control"-->
<!--                                    :value="value.reserve_status_id"-->
<!--                                    @input="updateField('reserve_status_id', $event.target.value)"-->
<!--                                >-->
<!--                                    <option value="">Selecione um status</option>-->
<!--                                    <option-->
<!--                                        v-for="status in reserveStatus"-->
<!--                                        :key="status.id"-->
<!--                                        :value="status.id"-->
<!--                                    >-->
<!--                                        {{ status.title }}-->
<!--                                    </option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <!-- Seção de Horas Mínimas -->
                <div class="parameter-section">
                    <h6 class="section-subtitle">
                        <i class="fas fa-clock mr-2"></i>
                        Controle de Horários
                    </h6>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label
                                    for="minimal_hours"
                                    class="form-label"
                                >
                                    <span class="required">*</span>
                                    Mínimo de horas entre retirada e devolução
                                </label>
                                <input
                                    id="minimal_hours"
                                    type="number"
                                    class="form-control"
                                    :value="value.minimal_hours"
                                    @input="updateField('minimal_hours', $event.target.value)"
                                    placeholder="Ex: 1"
                                    min="1"
                                />
                                <small class="form-text text-muted">
                                    Tempo mínimo que o veículo deve ficar reservado
                                </small>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label
                                    for="period_reserve"
                                    class="form-label"
                                >
                                    <span class="required">*</span>
                                    Mínimo de horas entre reservas do mesmo veículo
                                </label>
                                <input
                                    id="period_reserve"
                                    type="number"
                                    class="form-control"
                                    :value="value.period_reserve"
                                    @input="updateField('period_reserve', $event.target.value)"
                                    placeholder="Ex: 2"
                                    min="1"
                                />
                                <small class="form-text text-muted">
                                    Intervalo obrigatório entre reservas consecutivas
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Seção de Controles Especiais -->
                <div class="parameter-section">
                    <h6 class="section-subtitle">
                        <i class="fas fa-shield-alt mr-2"></i>
                        Controles de Segurança
                    </h6>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="custom-control custom-switch">
                                    <input
                                        id="lock_check_in"
                                        type="checkbox"
                                        class="custom-control-input"
                                        :checked="value.lock_check_in"
                                        @change="updateField('lock_check_in', $event.target.checked)"
                                    />
                                    <label
                                        class="custom-control-label"
                                        for="lock_check_in"
                                    >
                                        <div class="switch-content">
                                            <i class="fas fa-lock mr-2"></i>
                                            <div>
                                                <strong>Bloquear veículos após check-in</strong>
                                                <small class="d-block text-muted">
                                                    Impede novas reservas até o check-out
                                                </small>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Seção de Limitação de Lista -->
                <div class="parameter-section">
                    <h6 class="section-subtitle">
                        <i class="fas fa-list mr-2"></i>
                        Controle de Visualização
                    </h6>
                    <div class="row">
                        <div class="col-md-6 my-auto">
                            <div class="form-group">
                                <div class="custom-control custom-switch">
                                    <input
                                        id="limit_list_vehicles"
                                        type="checkbox"
                                        class="custom-control-input"
                                        :checked="value.limit_list_vehicles"
                                        @change="updateField('limit_list_vehicles', $event.target.checked)"
                                    />
                                    <label
                                        class="custom-control-label"
                                        for="limit_list_vehicles"
                                    >
                                        <div class="switch-content">
                                            <i class="fas fa-eye-slash mr-2"></i>
                                            <div>
                                                <strong>Limitar lista de veículos</strong>
                                                <small class="d-block text-muted">
                                                    Para usuários convencionais
                                                </small>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-md-6"
                            v-if="value.limit_list_vehicles"
                        >
                            <div class="form-group">
                                <label
                                    for="max_list_vehicles"
                                    class="form-label"
                                >
                                    <span class="required">*</span>
                                    Máximo de veículos a exibir
                                </label>
                                <input
                                    id="max_list_vehicles"
                                    type="number"
                                    class="form-control"
                                    :value="value.max_list_vehicles"
                                    @input="updateField('max_list_vehicles', $event.target.value)"
                                    placeholder="Ex: 10"
                                    min="1"
                                    max="100"
                                />
                                <small class="form-text text-muted">
                                    Número máximo de veículos mostrados por vez
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardHeader from "../../Base/CardHeader.vue";

export default {
    name: 'ReserveConfig',
    components: {CardHeader},
    // nome do componente de configuração de reserva
    props: {
        value: {
            type: Object,
            required: true
        },
        reserveStatus: {
            type: Array,
            default: () => []
        },
    },
    methods: {
        updateField(field, newValue) {
            this.$emit('update', field, newValue);
        }
    }
};
</script>

<style scoped>
.config-section {
    border: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-bottom: 25px;
    overflow: hidden;
}

.card-header {
    background: linear-gradient(135deg, #17a2b8, #138496);
    padding: 15px 20px;
    border-bottom: none;
}

.card-title {
    color: white;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.required-fields {
    font-size: 12px;
    opacity: 0.9;
}

.required {
    color: #ffeb3b;
    font-weight: bold;
}

.card-body {
    padding: 25px 20px;
    background-color: white;
}

.parameter-section {
    margin-bottom: 30px;
    padding-bottom: 25px;
    border-bottom: 1px solid #e9ecef;
}

.parameter-section:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}

.section-subtitle {
    color: #495057;
    font-weight: 600;
    margin-bottom: 20px;
    padding-bottom: 8px;
    border-bottom: 2px solid #f8f9fa;
    display: flex;
    align-items: center;
}

.section-subtitle i {
    color: #17a2b8;
}

.form-group {
    margin-bottom: 20px;
}

.form-label {
    font-weight: 600;
    color: #5b5b5f;
    margin-bottom: 8px;
    display: block;
}

.form-control {
    height: 45px;
    padding: 12px 15px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-size: 14px;
    background-color: white;
}

.form-control:focus {
    border-color: #17a2b8;
    box-shadow: 0 0 0 3px rgba(23, 162, 184, 0.25);
    outline: none;
}

.form-control.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    display: block;
    color: #dc3545;
    font-size: 12px;
    margin-top: 5px;
}

.form-text {
    font-size: 12px;
    color: #6c757d;
    margin-top: 5px;
}

/* Select personalizado */
select.form-control {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2317a2b8' d='M6 8.825l-6-6h12z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding-right: 35px;
}

/* Custom Switch */
.custom-control-input:checked ~ .custom-control-label::before {
    background-color: #17a2b8;
    border-color: #17a2b8;
}

.custom-control-label {
    position: relative;
    margin-bottom: 0;
    padding-left: 2rem;
}

.switch-content {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.switch-content i {
    margin-top: 2px;
    color: #17a2b8;
}

/* Responsividade */
@media (max-width: 768px) {
    .card-title {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .required-fields {
        align-self: flex-end;
    }

    .switch-content {
        flex-direction: column;
        gap: 4px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Parameters/components/ReserveConfig.vue